import { Component, ElementRef, Input, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { ModalConfig } from '../../modal-config';
import { SelectSearchFilter } from 'src/app/shared/select-search-filter';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { CountryService } from 'src/app/_services/country.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ModalService } from '../../modal.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { BusinessConflict, ConflictChoice, ConflictSource, Resolutions, CONFLICT_ANCHOR, isParentUnlink } from '../../conflict/conflict.model';
import { UnlinkNotice } from '../../conflict/conflict-resolver.component';
declare var $: any;

@Component({
  selector: 'app-student-modal',
  templateUrl: './student-modal.component.html',
  styleUrls: ['./student-modal.component.scss']
})
export class StudentModalComponent implements OnDestroy {
  @Input() config!: ModalConfig;
  @Input() lang: string;
  // the modal's own file input — never look it up by id, other components on the
  // same page use the same id and getElementById would hand us theirs
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;
  addStudentForm: UntypedFormGroup;
  addParentForm: UntypedFormGroup;
  phoneServerErrors: string[] = [];
  studentID: number;
  clazz;
  grades = [];
  classes = [];
  allergies = [];
  diseases = [];
  permittedUsers = [];
  mappedPermittedUsers = [];
  countries = [];
  gradeSearch = new SelectSearchFilter<any>('name');
  classSearch = new SelectSearchFilter<any>('name');

  latitude: number;
  longitude: number;
  address: string;
  mapControls;

  imageFile;
  selectedImage;
  image;
  qrCode: string;

  parentExistsInSystem: boolean = false;
  mapView = '';
  showedNumber:number;

  /**
   * The one conflict the endpoint is currently reporting. It reports one at a
   * time and so does the UI: when the next one arrives this is replaced, so a
   * second conflict on the same field cannot collide with a stale panel.
   */
  conflict: BusinessConflict = null;
  /** Answers gathered so far — sent as resolutions[field][source] on every save. */
  resolutions: Resolutions = {};
  savingStudent = false;
  /** S1 unlink: why the last save did not go through, shown in the dialog. */
  unlinkNotice: UnlinkNotice = null;
  /** S1 unlink: parents the server added to the list on a stale 409. */
  updatedParentIds: number[] = [];
  /** Name of the parent picked for unlinking, for the success toast. */
  private unlinkName: string = null;

  usersTableControls: any = { data: [] };

  constructor(
    // private mapsAPILoader: MapsAPILoader,
    private _snackBar: MatSnackBar,
    private ngZone: NgZone,
    private dataService: DataService,
    private countryService: CountryService,
    private translate: TranslateService,
    private parentService: ParentService,
    private snackbarService: SnackbarService,
    private studentService: StudentService,
    private gradesService: GradeService,
    private globalService: GlobalService,
    private modalService: ModalService,
    private qrControl: ControlQrService
  ) { }

  ngOnInit() {
    console.log('addStudentConfig', this.config);
    console.log('addStudentLang', this.lang);
    this.setMapView('init');
    // lat long of school
    this.initLatLng();
    this.initFormFields();
    this.getGrades();
    this.getCountries();
    if (this.config.mode != 'add') {
      this.setEditValues();
    }
    // this.getHealthCondition();
    this.dataService.getRowsNumberShown().subscribe(res => {
      this.showedNumber = res
    })
  }

  initFormFields() {
    this.addStudentForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      gender: new UntypedFormControl(''),
      grade_id: new UntypedFormControl('', Validators.required),
      class_id: new UntypedFormControl('', Validators.required),
      diseases: new UntypedFormControl(''),
      allergies: new UntypedFormControl(''),
    })

    this.addParentForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      gender: new UntypedFormControl(''),
      country_code: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')])
    })
  }
  getGrades() {
    this.dataService.getAllGrades()?.subscribe(res => {
      this.grades = res;
      this.gradeSearch.setSource(this.grades);
    })
  }

  getHealthCondition() {
    this.dataService.getHealthConditions()?.subscribe((res: any) => {
      let { disease, allergy } = res['health_conditions']
      this.diseases = disease;
      this.allergies = allergy;
    })
  }

  setEditValues() {
    if (this.config?.data) {
      this.image = environment.img_url + this.config?.data?.image_path;
      this.qrCode = this.config?.data?.qr_code ? environment.img_url + this.config?.data?.qr_code : null;
      this.permittedUsers = [...this.config?.data?.parent, ...this.config?.data?.helpers];
      this.studentID = this.config?.data?.id;
      this.clazz = this.config?.data?.class;

      for (const i in this.addStudentForm.value) {
        this.addStudentForm.controls[i].setValue(this.config?.data[i]);
      }
      // this.allergies
      this.addStudentForm.controls['diseases'].setValue(this.config?.data?.diseases.map(disease => {
        return disease.id
      }))
      this.addStudentForm.controls['allergies'].setValue(this.config?.data?.allergies.map(allergie => {
        return allergie.id
      }))

      this.addStudentForm.controls.grade_id.setValue(this.config?.data?.class?.grade_id);
      this.onGradeChange();
      this.addStudentForm.controls.class_id.setValue(this.config?.data?.class?.id);
      for (const i in this.addParentForm.value) {
        this.addParentForm.controls[i].setValue(this.config?.data?.parent[0][i])
      }
    }
    this.mapUsersArray(this.permittedUsers);
  }

  openQrModal() {
    if (this.config?.data) {
      // Transform data to match the format expected by QR modal
      const studentData = {
        ...this.config.data,
        grade: this.config.data.class?.grade?.name || '',
        class: this.config.data.class?.name || ''
      };
      this.qrControl.setStudentData(studentData, 'single');
      $('#qrStudentModal').modal('show');
    }
  }

  initLatLng() {
    this.latitude = this.config?.data?.parent[0].lat ? this.config?.data?.parent[0].lat : null;
    this.longitude = this.config?.data?.parent[0].long ? this.config?.data?.parent[0].long : null;
    this.address = this.config?.data?.parent[0].address;
    this.initMapControls();
  }

  getCountries() {
    this.countries = this.countryService.countries;
  }

  mapEventHandle(event) {
    switch (event.type) {
      case "updateAdress":
        this.address = event.data;
        this.latitude = event.lat;
        this.longitude = event.lng;
        break;
    }
  }
  initMapControls() {
    this.mapControls = {
      mapPoint: {
        lat: this.latitude,
        long: this.longitude,
      }
    }
  }

  setMapView(viewCycle) {
    this.mapView = viewCycle == 'init' ? 'add-student' : 'add-student-destroyed';
  }

  // image upload
  changeStudentProfile() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }

  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }


  onGradeChange() {
    this.addStudentForm.controls.class_id.reset();
    let selectedGrade: any;
    selectedGrade = this.grades.filter(grade => grade.id === this.addStudentForm.value.grade_id);
    this.classes = selectedGrade[0].school_classes;
    this.classSearch.setSource(this.classes);
    this.classSearch.reset();
    if (this.classes.length === 0) {
      this.addStudentForm.controls.class_id.setErrors({ 'required': true })
      this.addStudentForm.controls.class_id.markAsTouched();
    }
  }

  getSerachByIdLabel() {
    let label = this.lang === 'en' ? 'Check Parent ID' : 'تحقق من رقم الهوية للأب';
    return label;
  }

  searchById() {
    if (this.addParentForm.value.national_id !== '') {
      this.parentService.searchByUserId(this.addParentForm.value.national_id).subscribe((res: any) => {
        console.log('searchParentById', res);
        this.parentExistsInSystem = true;
        this.addParentForm.controls.name.setValue(res.name);
        this.addParentForm.controls.national_id.setValue(res.national_id);
        this.addParentForm.controls.gender.setValue(res.gender);
        this.addParentForm.controls.country_code.setValue(res.country_code);
        this.addParentForm.controls.phone.setValue(res.phone);
        this.addParentForm.controls.email.setValue(res.email);
        this.latitude = res.lat;
        this.longitude = res.long;
        this.address = res.address;
        this.initMapControls();
        this.clearParentConflicts();
      },
        (error) => {
          this.parentExistsInSystem = false;
          this.snackbarService.setSnackBarMessage(error.error.message);
          this._snackBar.openFromComponent(SnackBarErrorComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        })
    }
    else {
      this.addParentForm.controls.national_id.markAsTouched();
    }
  }

  // validation function for student form
  getStudentFormValidation(control: string) {
    let errorMSG;
    if (this.addStudentForm.controls[control].errors) {
      if (control == 'name') {
        errorMSG = this.addStudentForm.controls[control].errors.required ? this.translate.instant('user-management.error-msgs.student-name-required') :
          this.addStudentForm.controls[control].errors.incorrect ?
            this.translate.instant('user-management.error-msgs.student-name-exist') :
            this.translate.instant('user-management.error-msgs.student-name-notValid');
      } else {
        errorMSG = this.addStudentForm.controls[control].errors.required ? this.translate.instant('user-management.error-msgs.national-id-required') :
          this.addStudentForm.controls[control].errors.incorrect ?
            this.translate.instant('user-management.error-msgs.national-id-exist') :
            this.translate.instant('user-management.error-msgs.national-id-notValid');
      }
    }
    return errorMSG;
  }

  // validation function for parent form
  getParentFormValidation(control: string) {
    let errorMSG;
    if (this.addParentForm.controls[control].errors) {
      switch (control) {
        case 'name':
          errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('user-management.error-msgs.parent-name-required') :
            this.translate.instant('user-management.error-msgs.parent-name-notValid');
          break;
          case 'phone':
            errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('user-management.error-msgs.phone-required') :
            this.addParentForm.controls[control].errors.incorrect ? this.translate.instant('edit-parent.phone-exists')
            :this.translate.instant('edit-parent.phone-valid');
            break;
          case 'email':
            errorMSG = this.addParentForm.controls[control].errors.required ? this.translate.instant('user-management.error-msgs.email-required') :
            this.addParentForm.controls[control].errors.incorrect ? this.translate.instant('edit-parent.email-exists')
            :this.translate.instant('edit-parent.email-valid');
        default:
          break;
      }
      // errorMSG = this.addParentForm.controls[control].errors.required ? `${control.includes('_') ? control.replace('_', ' ') : control} is required` :
      //   `${control.includes('_') ? control.replace('_', ' ') : control} is not valid`;
    }
    return errorMSG;
  }

  getIDErrorMessage() {
    let errorMSG;
    if (this.addParentForm.controls.national_id.errors) {
      errorMSG = this.addParentForm.controls.national_id.errors.required ?
        this.translate.instant('user-management.error-msgs.national-id-required') :
        // this.addParentForm.controls.national_id.errors.pattern ?
        this.translate.instant('user-management.error-msgs.national-id-notValid');
      // 'National ID is not found'
    }
    return errorMSG;
  }

  getImage(url) {
    return environment.img_url + url;
  }

  /** Is the current conflict anchored under this control? */
  showsConflictAt(control: string): boolean {
    return !!this.conflict && CONFLICT_ANCHOR[this.conflict.field] === control;
  }

  /** An unanswered conflict blocks the save; a terminal one blocks it for good. */
  get conflictBlocksSave(): boolean {
    if (!this.conflict) {
      return false;
    }
    if (isParentUnlink(this.conflict) && this.unlinkNotice === 'permission') {
      return true;
    }
    return !this.conflict.resolvable || !this.resolutions[this.conflict.field];
  }

  /**
   * Record the choice and show the winning value in the form, so the admin can
   * see what will be saved. Nothing is sent yet — they press Save themselves,
   * which keeps a mis-click undoable through the panel's Change button.
   */
  onConflictChoice(choice: ConflictChoice): void {
    if (choice.source === 'remove') {
      // Unlinking leaves the parent form as typed: it is the new parent.
      this.resolutions = { ...this.resolutions, [choice.field]: { source: 'remove', user_id: choice.user_id } };
      this.unlinkName = this.conflict?.parents?.find(p => p.user_id === choice.user_id)?.parent_name || null;
      if (this.unlinkNotice === 'stale') {
        this.unlinkNotice = null;
      }
      return;
    }
    this.resolutions = { ...this.resolutions, [choice.field]: { source: choice.source } };
    this.applyChoiceToForm(this.conflict, choice.source);
  }

  /**
   * A resolution answers a question about one specific value. The moment the
   * admin edits that value the answer is stale, so drop it — and drop the
   * panel too, since its cards compare values that no longer apply. The next
   * save re-evaluates from scratch.
   */
  onResolvedFieldEdited(field: string): void {
    if (this.resolutions[field]) {
      const next = { ...this.resolutions };
      delete next[field];
      this.resolutions = next;
    }
    if (this.conflict?.field === field) {
      this.setConflict(null);
    }
  }

  /** A new or cleared conflict starts without the previous one's notices. */
  private setConflict(conflict: BusinessConflict, notice: UnlinkNotice = null, updatedIds: number[] = []): void {
    this.conflict = conflict;
    this.unlinkNotice = notice;
    this.updatedParentIds = updatedIds;
  }

  /**
   * The ID search adopts a whole guardian from the system, so every parent
   * value a conflict was raised about is gone — as is the answer to it. The
   * fields also turn readonly from here, so no edit event would ever clear
   * them. The parent limit goes too: the guardian just picked may well be one
   * of the two already linked, which links nothing new and saves normally.
   * Whatever still applies comes back on the next save.
   */
  private clearParentConflicts(): void {
    ['parent_national_id', 'parent_phone', 'parent_email', 'student_parent_limit']
      .forEach(field => this.onResolvedFieldEdited(field));
  }

  /**
   * Changing the student invalidates any answer about that student — an
   * unlink included, since it names one of that student's parents.
   */
  onStudentIdentityEdited(): void {
    this.onResolvedFieldEdited('student_in_other_school');
    this.onResolvedFieldEdited('student_parent_limit');
  }

  /** Put back what the admin originally typed and re-open the choice. */
  onConflictUndo(field: string): void {
    const next = { ...this.resolutions };
    const wasUnlink = next[field]?.source === 'remove';
    delete next[field];
    this.resolutions = next;
    if (!wasUnlink) {
      this.patchParentFromGuardian(this.conflict?.submitted_value);
    }
  }

  /**
   * Adopt the card that was pressed, whole. Each card shows a complete
   * guardian, so "Use this" has to leave the form matching that card exactly —
   * mixing the two sides would show a guardian neither card described.
   *
   * `submitted_value` is the server's echo of what was posted, so it doubles as
   * the "restore what I typed" source when a choice is undone.
   */
  private applyChoiceToForm(conflict: BusinessConflict, source: ConflictSource): void {
    const chosen: any = source === 'existing' ? conflict?.existing_value : conflict?.submitted_value;
    // student_in_other_school carries schools, student_parent_limit carries
    // nothing — neither maps onto a parent field.
    if (!chosen || !chosen.parent_national_id) {
      return;
    }
    this.patchParentFromGuardian(chosen);
  }

  /**
   * Shows one whole guardian in the form — name and email included, exactly as
   * its card listed them. Only the keys the card actually carries are written,
   * so a partial payload leaves the rest of what the admin typed alone instead
   * of blanking it.
   */
  private patchParentFromGuardian(values: any): void {
    if (!values) {
      return;
    }
    const phone = this.splitGuardianPhone(values);
    const patch = {
      name: values.parent_name,
      national_id: values.parent_national_id,
      email: values.parent_email,
      country_code: phone.country_code,
      phone: phone.phone,
    };
    for (const control in patch) {
      if (patch[control] !== undefined) {
        this.addParentForm.controls[control].setValue(patch[control] ?? '');
      }
    }
  }

  /**
   * A guardian reports its phone either already split (`parent_country_code` +
   * `parent_phone`) or as the single E.164 string the cards display
   * (`parent_phone_number`), while the form always keeps the two apart. Match
   * the combined form against the known dial codes — longest first, since some
   * are prefixes of others — so the number lands in the right box.
   */
  private splitGuardianPhone(values: any): { country_code?: string; phone?: string } {
    if (values.parent_country_code !== undefined || values.parent_phone !== undefined) {
      return { country_code: values.parent_country_code, phone: values.parent_phone };
    }
    const full: string = values.parent_phone_number;
    if (!full) {
      return { phone: full === undefined ? undefined : '' };
    }
    const code = this.countries
      .map(country => country?.code_plus)
      .filter(code_plus => !!code_plus && full.startsWith(code_plus))
      .sort((a, b) => b.length - a.length)[0];
    return code ? { country_code: code, phone: full.slice(code.length) } : { phone: full };
  }

  sanitizeDataBeforeSendToServer(): void {
    let parentGender = this.addParentForm.get('gender');
    let studentGender = this.addStudentForm.get('gender');
    if ((parentGender.value as string)?.trim() === '' || parentGender.value == "noParentGender" || parentGender.value == null) {
      delete this.addParentForm.value['gender'];
    }
    if ((studentGender.value as string)?.trim() === '' || studentGender.value == "noStudentGender" || studentGender.value == null) {
      delete this.addStudentForm.value['gender'];
    }
  }
  /** Parents on the refreshed S1 list that were not on the one the admin saw. */
  private newParentIds(previous: BusinessConflict, next: BusinessConflict): number[] {
    const seen = (previous?.parents || []).map(p => p.user_id);
    return (next?.parents || []).map(p => p.user_id).filter(id => !seen.includes(id));
  }

  private showUnlinkSuccess(): void {
    const message = this.translate.instant('student-conflicts.success', {
      n: this.addParentForm.value?.name || '',
      p: this.unlinkName || '',
    });
    this._snackBar.open(message, '', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['copy-success-snackbar'],
    });
  }

  private dropResolution(field: string): void {
    const next = { ...this.resolutions };
    delete next[field];
    this.resolutions = next;
  }

  /**
   * The S1 unlink errors the dialog explains itself. The choice is kept unless
   * the server says it no longer applies.
   *   403 -> this role may not unlink; Unlink & save stays off.
   *   422 on the chosen user_id -> that parent is no longer linked: drop the
   *          answer and re-post to get the current list.
   *   no response / 5xx -> try again.
   */
  private handleUnlinkError(error: any): boolean {
    if (error?.status === 403) {
      this.unlinkNotice = 'permission';
      return true;
    }
    const errors = error?.status === 422 ? error?.error?.errors || {} : {};
    if (Object.keys(errors).some(key => key.startsWith('resolutions.student_parent_limit'))) {
      this.dropResolution('student_parent_limit');
      this.unlinkNotice = 'stale';
      this.saveStudent(true);
      return true;
    }
    if (!error?.status || error.status >= 500) {
      this.unlinkNotice = 'network';
      return true;
    }
    return false;
  }

  // add student
  // `refreshing`: a re-post after the server rejected the unlink choice, to get
  // the current parent list.
  saveStudent(refreshing = false) {
    this.phoneServerErrors = [];
    this.sanitizeDataBeforeSendToServer();
    const formData = new FormData();

    let student_info = { ...this.addStudentForm.value }
    let diseases = student_info.diseases;
    let allergies = student_info.allergies;
    delete student_info.diseases;
    delete student_info.allergies;



    for (const i in student_info) {
      formData.append(i, student_info[i])
    }
    if (this.imageFile) {
      formData.append('image', this.imageFile);
    }
    const omitEmptyParentFields = this.config?.mode == 'add';
    for (const i in this.addParentForm.value) {
      const parentValue = this.addParentForm.value[i];
      // v2 has no null: "no email" means omitting parent[email] entirely, not
      // sending it empty. FormData would also stringify a null to "null".
      const isEmpty = parentValue === null || parentValue === undefined || parentValue === '';
      if (omitEmptyParentFields && isEmpty) {
        continue;
      }
      if (parentValue !== null && parentValue !== undefined) {
        formData.append(`parent[${i}]`, parentValue)
      }
    }
    // resolutions[field][source] — the nested shape the endpoint expects.
    // The winning value is never sent; the server resolves it itself.
    for (const field in this.resolutions) {
      formData.append(`resolutions[${field}][source]`, this.resolutions[field].source)
      if (this.resolutions[field].user_id !== undefined) {
        formData.append(`resolutions[${field}][user_id]`, String(this.resolutions[field].user_id))
      }
    }
    // if(this.formFlag=='edit'){

    //   for (const i in diseases) {
    //     formData.append(`diseases[]`, diseases[i])
    //   }

    //     for (const i in allergies) {
    //       formData.append(`allergies[]`, allergies[i])
    //   }
    // }
    if (this.latitude !== null && this.longitude !== null) {
      formData.append('parent[lat]', this.latitude.toString())
      formData.append('parent[long]', this.longitude.toString())
      formData.append('parent[address]', this.address)
    }

    if (this.config?.mode == 'add') {
      // adding new student
      // Lets the server offer `remove` on S1; without it S1 stays terminal.
      formData.append('supports_parent_unlink', '1');
      const unlinking = this.resolutions.student_parent_limit?.source === 'remove';
      // A retry starts clean; a refusal (permission) or a refresh stays put.
      if (this.unlinkNotice === 'network') {
        this.unlinkNotice = null;
      }
      this.savingStudent = true;
      this.studentService.addStudentV2(formData).subscribe(res => {
        this.savingStudent = false;
        this.setConflict(null);
        if (unlinking) {
          this.showUnlinkSuccess();
        }
        this.updateAllUsersObservable();
        this.closeModalHandler();
      },
        (error) => {
          this.savingStudent = false;
          // 409 = a business conflict the admin can answer. Only one is
          // reported per request, so answering it may reveal the next.
          if (error?.status === 409 && error?.error?.conflict) {
            const next: BusinessConflict = error.error.conflict;
            // S1 again after an unlink = the parent list changed under the
            // admin. The answer named a parent from the old list, so it goes,
            // and the dialog shows the fresh list.
            if ((unlinking || refreshing) && next.field === 'student_parent_limit') {
              const updated = this.newParentIds(this.conflict, next);
              this.dropResolution('student_parent_limit');
              this.setConflict(next, 'stale', updated);
              return;
            }
            // Replaces the previous one: only the conflict still to be answered
            // is ever on screen. Earlier answers stay in `resolutions`.
            this.setConflict(next);
            return;
          }
          if (unlinking && this.handleUnlinkError(error)) {
            return;
          }
          if (error?.error?.errors) {
            const errors = error.error.errors;
            if (errors['parent.phone']) {
              this.addParentForm.controls['phone'].setErrors({ 'incorrect': true });
              this.addParentForm.controls['phone'].markAsTouched();
              this.phoneServerErrors = errors['parent.phone'];
            }
            Object.keys(errors)
              .filter(key => key !== 'parent.phone')
              .map(element => {
              const controlKey = element.includes('parent.') ? element.substring(7) : element;
              if (this.addParentForm.controls[controlKey]) {
                this.addParentForm.controls[controlKey].setErrors({ 'incorrect': true });
                this.addParentForm.controls[controlKey].markAsTouched();
              }
            })
          }
          else {
            this.snackbarService.setSnackBarMessage(error.error.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
    }
    else {
      // updating student
      this.studentService.updateStudent(this.studentID, formData).subscribe(res => {
        this.gradesService.getSingleClass(this.clazz.id).subscribe(res => {
          this.gradesService.setGradesReload();
          this.gradesService.setClassData(res);
        })
        this.updateAllUsersObservable();
        this.closeModalHandler();
      },
        (error) => {
          if (error?.error?.errors) {
            Object.keys(error.error.errors).map(element => {
              this.addStudentForm.controls[element].setErrors({ 'incorrect': true });
              this.addStudentForm.controls[element].markAsTouched();
            })
          }
          else {
            this.snackbarService.setSnackBarMessage(error.error.message);
            this._snackBar.openFromComponent(SnackBarErrorComponent, {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
    }
  }

  updateAllUsersObservable(){
    this.dataService.getUsers$().subscribe(res=>{
      this.dataService.setUsers$(res);
    })
  }

  
  mapUsersArray(usersArray:any){
    this.mappedPermittedUsers = usersArray.map(user => (
      {
        user_image: user.image_path,
        name: user.name,
        national_id: user.national_id,
        role: this.translate.instant(
          user?.pivot?.type === 'helper' ? 'edit-parent.role-helper' : 'edit-parent.role-parent'
        )
      }
    ));
    this.setUsersTableData();
  }

  setUsersTableData() {
    this.usersTableControls = {
      selection: false,
      paging: false,
      view: 'list',
      title: 'edit-parent.permitted-user',
      totalTitle: 'table-view.total-titles.users',
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "user_image"
        },
        {
          name: this.translate.instant('edit-parent.relative-name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('edit-parent.national-id'),
          sort: false,
          type: "string",
          source: "national_id"
        },
        {
          name: this.translate.instant('edit-parent.role'),
          sort: false,
          type: "string",
          source: "role"
        }
      ],
      data: this.mappedPermittedUsers
    }
  }

  closeModalHandler(){
    this.dataService.setRowsNumberShown(this.showedNumber);
    this.modalService.closeModal();
  }

  ngOnDestroy() {
    this.gradeSearch.destroy();
    this.classSearch.destroy();
  }
}
